import { DesignIcon, SystemIcon } from '@monorepo/nova-icons';
import { Box, IconButton, Stack, useTheme } from '@monorepo/nova-ui';

const BalanceDialogHeader = ({ onClose }: { onClose: () => void }) => {
  const { palette, typography } = useTheme();
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
    >
      <Box
        sx={{
          padding: typography.pxToRem(24),
          paddingRight: typography.pxToRem(8),
        }}
      >
        <DesignIcon
          useMuiSvgIcon={false}
          iconName={`BalanceCoins`}
          sx={{
            fill: palette.background.default,
            width: 104,
            height: 73,
          }}
        />
      </Box>

      <IconButton
        onClick={onClose}
        sx={{
          p: 0,
        }}
      >
        <SystemIcon
          iconName="X"
          color={palette.background.opposite}
          sx={{
            width: 24,
            height: 24,
          }}
        />
      </IconButton>
    </Stack>
  );
};

export default BalanceDialogHeader;
